<script setup lang="ts">
import { AppTrashCanButton } from '@libs/ui';

interface ActivityCardHeaderProps {
  printMode: boolean;
}

const props = defineProps<ActivityCardHeaderProps>();

interface ActivityCardHeaderEmits {
  (event: 'remove'): void;
}

const emit = defineEmits<ActivityCardHeaderEmits>();

function removeActivity(): void {
  emit('remove');
}
</script>

<template>
  <div class="activity-card-header">
    <AppTrashCanButton
      v-if="!props.printMode"
      class="icon"
      :aria-label="$t('a11y.remove_activity')"
      @click="removeActivity"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  position: relative;
  width: 100%;

  .icon {
    position: absolute;
    right: 0;
    color: var(--color-neutral-70);
  }
}
</style>
